import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  imagesStore: []
};

export const imageSlice = createSlice({
  name: 'imageSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addImage: (state, action) => {
      state.imagesStore.push(action.payload);
    }
  },
});

export const { addImage } = imageSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const imagesStore = (state: RootState) => state.images.imagesStore;

export default imageSlice.reducer;
